// Цвет партии: закраска ячейки в разнарядке и отчётах. Цвет задаётся на странице «Партии» (#RRGGBB).

// Готовые цвета для быстрого выбора
export const BATCH_PALETTE = [
  '#fde68a', '#fed7aa', '#fecaca', '#fbcfe8', '#e9d5ff', '#c7d2fe',
  '#bfdbfe', '#a5f3fc', '#bbf7d0', '#d9f99d', '#e5e7eb', '#d6c7a1'
]

const HEX = /^#[0-9a-fA-F]{6}$/

export function isColor(value) {
  return typeof value === 'string' && HEX.test(value)
}

// Тёмный или светлый текст на этом фоне — по яркости цвета
export function textOn(color) {
  if (!isColor(color)) return ''
  const r = parseInt(color.slice(1, 3), 16)
  const g = parseInt(color.slice(3, 5), 16)
  const b = parseInt(color.slice(5, 7), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#1f2937' : '#ffffff'
}

// Стиль закраски: фон цветом партии, граница чуть темнее, читаемый текст; без цвета — пусто
export function batchStyle(color) {
  if (!isColor(color)) return null
  return { background: color, borderColor: color, color: textOn(color) }
}
